// MyProjects.js
import React, { useCallback, useEffect, useState, useRef } from 'react';
import useFetch from '../../hooks/useFetch';

import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import MainLayout from '../../layouts/MainLayout';
import "../../styles/MyProfile.css";
import Tooltip from '../../components/utils/Tooltip';

const MyProjects = () => {
  const authState = useSelector(state => state.authReducer);
  const [fetchData] = useFetch();

  const navigate = useNavigate();
  const userId = authState.user._id;
  const [createdProjects, setCreatedProjects] = useState([]);
  const [hasCretaedProjectStatus, setHasCretaedProjectStatus] = useState(false);
  const [hasCretaedProjectStatusMsg, setHasCretaedProjectStatusMsg] = useState('');
  const [selectedProjectId, setSelectedProjectId] = useState([]);
  const [selectedViewMemberProjectId, setSelectedViewMemberProjectId] = useState(false);
  const [selectedAddMemberProjectId, setSelectedAddMemberProjectId] = useState(false);

  const [hasNewMemberCodeClicked, setHasNewMemberCodeClicked] = useState(false);
  // const [newMemberCode, setNewMemberCode] = useState('');

  const [newMemberCodeStatus, setNewMemberCodeStatus] = useState(false);
  const [newMemberCodeStatusMsg, setNewMemberCodeStatusMsg] = useState('');
  const [newMemberCode, setNewMemberCode] = useState('');
  const [newMemberId, setNewMemberId] = useState('');
  const [newMemberName, setNewMemberName] = useState('');
  const [newMemberEmail, setNewMemberEmail] = useState('');
  const [newMemberCodeMsg, setNewMemberCodeMsg] = useState('');
  const [verifyNewMemberCodeButtonClicked, setVerifyNewMemberCodeButtonClicked] = useState(false);
  const [error, setError] = useState('');
  const [addNewButtonClickedStatus, setAddNewButtonClickedStatus] = useState(false);
  const [addNewMemberRecordStatus, setAddNewMemberRecordStatus] = useState(false);
  const [addNewMemberRecordStatusMsg, setAddNewMemberRecordStatusMsg] = useState('');

  useEffect(() => {
    fetchMyProjectList(); 
  }, []);

   const fetchMyProjectList = useCallback(() => {
    // console.log("fetchMyProjectList for API call ", userId);
    const config = {
        url: "/myprojects/mycreatedlist",
        method: "post",
        headers: { Authorization: authState.token },
        data: { createdBy: userId }
    };
  
    fetchData(config)
        .then(response => {
          // console.log("API Response: ", response); 
            if (response && response.status) {
                // console.log("project list found ", response);
                setHasCretaedProjectStatus(true);
                setCreatedProjects(response.projects);
                setHasCretaedProjectStatusMsg("Projects found. 😊");
            } else {
                // console.log("Projects Code Not found");
                setHasCretaedProjectStatusMsg(`Projects not found! 😔`);
            }
        })
        .catch(error => {
            // console.log("Projects Not found!", error);
            setHasCretaedProjectStatusMsg("Error in getting data");
        });
  }, [fetchData, authState.token]);
  
  
  useEffect(() => {
    if (!authState.isLoggedIn) return;
  }, [authState.isLoggedIn, fetchMyProjectList]);

// here
const newMemberCodeValidationClicked = (newMemberCode) => {
  if (/^TU[a-zA-Z0-9]{12}$/.test(newMemberCode)) {
      fetchNewMemberCode(newMemberCode);
  } else {
      setError('Please enter a valid 14-character Think5Whys User Code starting with TU');
  }
};

const handleNewMemberCodeValidation = () => {
  setVerifyNewMemberCodeButtonClicked(true);
};

const fetchNewMemberCode = useCallback((newMemberCode) => {
  // console.log("newMemberCode for API call ", newMemberCode);
  const config = {
      url: "/auth/verifyt5wcode",
      method: "post",
      headers: { Authorization: authState.token },
      data: { think5whyscode: newMemberCode }
  };

  fetchData(config)
      .then(response => {
          if (response && response.status) {
              // console.log("newMemberCode found ", response);
              setNewMemberCodeStatus(true);
              setNewMemberId(response.t5wcode._id);
              setNewMemberName(response.t5wcode.name);
              setNewMemberCodeStatusMsg(`User Code ${newMemberCode} found. 😊`);
          } else {
              // console.log("User Not found");
              setNewMemberCodeStatus(false);
              setNewMemberCodeStatusMsg(`User Code ${newMemberCode} not found! 😔 Make sure the User Code is valid.`);
          }
      })
      .catch(error => {
          // console.log("newMemberCode Not found!");
          setNewMemberCodeStatus(false);
          setNewMemberCodeStatusMsg(`User Code ${newMemberCode} not found! 😔 Make sure the User Code is valid.`);
      });
}, [authState.token, fetchData, setNewMemberCodeStatus,setNewMemberId,setNewMemberName,setNewMemberName]);


useEffect(() => {
  if (!authState.isLoggedIn) return;
}, [authState.isLoggedIn, fetchNewMemberCode]);
//


const addNewButtonClicked = (projectid, projectCode, projectTitle, projectType, newMemberId, newMemberCode, newMemberName) => {
    setAddNewButtonClickedStatus(true);
    addNewMemberRecord(projectid, projectCode, projectTitle, projectType, newMemberId, newMemberCode, newMemberName);
};

const addNewMemberRecord = useCallback((projectid, projectCode, projectTitle, projectType, newMemberId, newMemberCode, newMemberName) => {
  // console.log("fetchAddNewMemberRecord for API call ", projectid, projectCode, projectTitle, projectType, newMemberId, newMemberCode, newMemberName);
  const newMemberData = {
    projectId: projectid, 
    projectCode: projectCode, 
    projectTitle: projectTitle,
    projectType: projectType,
    creatorCode: authState.user.think5whyscode,
    creatorName: authState.user.name,
    dateCreated: new Date(),
    memberId: newMemberId,
    memberCode: newMemberCode,
    memberName: newMemberName,
    remarks: "New Member "+newMemberName+" Joined in the Project "+projectTitle,
    createdBy: authState.user._id,
    isActive: 1,
    isDeleted: 0
  };

  const config = {
      url: "/myprojects/addnewmember",
      method: "post",
      headers: { Authorization: authState.token },
      data: { newMemberData }
  };
  // console.log("fetchAddNewMemberRecord for config call ", config);

  fetchData(config)
      .then(response => {
          if (response && response.status) {
              // console.log("newMemberCode added ", response);
              setAddNewMemberRecordStatus(true);
              setAddNewMemberRecordStatusMsg(`Project Member ${newMemberName} Added. 😊`);
          } else {
              // console.log("User Not added");
              setAddNewMemberRecordStatusMsg(`Project Member ${newMemberName} not added! 😔 Please retry.`);
          }
      })
      .catch(error => {
          // console.log("newMemberCode Not added!");
          setAddNewMemberRecordStatusMsg(`Project Member ${newMemberName} not added! 😔 Please retry.`);
      });
}, [fetchData, setAddNewMemberRecordStatus]);


useEffect(() => {
  if (!authState.isLoggedIn) return;
}, [authState.isLoggedIn, addNewMemberRecord]);

//

  const handleCreateProjectClick = () => {
    navigate("/myprofile-createproject");
  };

  const handleProjectView = (_id) => {
    setSelectedProjectId(prevId => (prevId === _id ? null : _id));
  };

  const handleAddMembers = (_id) => {
    setSelectedAddMemberProjectId(prevId => (prevId === _id ? null : _id));
  };

  const handleViewMembers = (_id) => {
    setSelectedViewMemberProjectId(prevId => (prevId === _id ? null : _id));
  };

  const formatDateTime = (dateString) => {
    const options = { year: 'numeric', month: 'long', day: 'numeric', hour: '2-digit', minute: '2-digit' };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };

  const projectTypeNames = {
    TEA: "Team",
    DEP: "Departmental",
    BRA: "Branch",
    ZON: "Zonal",
    REG: "Regional",
    COM: "Company Wide",
    INS: "Institutional",
    ADM: "Administration",
    MIN: "Ministry",
    PRO: "Professional",
    ACA: "Academic",
    MAN: "Management",
    CAM: "Others",
  };


  return (
    <MainLayout>
      <div className='text-lg mt-12 mx-8 border-b border-b-gray-300 text-white'>
        <h2>Profile - My Think5Whys Projects</h2>
      </div>
      <div className='m-auto my-2 p-2 border-2 shadow-md rounded-md md:w-7/12 w-full text-white'>
        <div className="flex justify-between mt-4 items-center border-b border-b-gray-300">
          <h3 className='text-lg mt-1 mx-2 text-white'>Projects I Created</h3>
          <button
            className='bg-purple-700'
            onClick={() => handleCreateProjectClick()}
            style={{ maxWidth: '150px' }}
          >
            Create New
          </button>
        </div>
        <div className="mt-4">
          {createdProjects.length === 0 ? (
            <div className='flex justify-center'>
              <p className='text-yellow-600 text-2xl mt-20 h-80'>You Have Not Created A Project Yet</p>
            </div>
          ) : (
            createdProjects.map((project, index) => (
              <div key={project._id} className='bg-gray-700 my-1 p-4 text-gray-600 rounded-md shadow-md'>
                <div className='flex'>
                  <span className='font-medium text-white'>
                    {index + 1}. {project.projectTitle}
                  </span>
                  <Tooltip text={"View details"} position={"top"}>
                    <span className='ml-auto mr-4 text-blue-500 cursor-pointer' onClick={() => handleProjectView(project._id)}>
                      <i className="fa-solid fa-eye"></i>
                    </span>
                  </Tooltip>
                  <Tooltip text={"Add Project Members"} position={"top"}>
                    <span className='ml-2 text-blue-500 cursor-pointer' onClick={() => handleAddMembers(project._id)}>
                      <i className="fa-solid fa-user-plus"></i>
                    </span>
                  </Tooltip>
                  <Tooltip text={"View Project Members List"} position={"top"}>
                    <span className='ml-2 text-blue-500 cursor-pointer' onClick={() => handleViewMembers(project._id)}>
                      <i className="fa-solid fa-users"></i>
                    </span>
                  </Tooltip>
                </div>
                {selectedProjectId === project._id && (
                  <div className='bg-gray-600 text-black'>
                    <p><strong>Project Type:</strong> {projectTypeNames[project.projectType]}</p>
                    <p><strong>Created Date:</strong> {formatDateTime(project.dateCreated)}</p>
                    <p><strong>Description:</strong>{project.projectDesc}</p>
                    <p><strong>Do's:</strong>{project.dos}</p>
                    <p><strong>Don't:</strong> {project.dont}</p>
                    <p><strong>Page:</strong> {project.projectMicroPage}</p>
                    <p><strong>My Project Remarks:</strong> {project.myProjectRemarks}</p>
                    <p><strong>Master Project Code:</strong> {project.masterProjectCode}</p>
                    <p><strong>Master Project Title:</strong> {project.masterProjectTitle}</p>
                    <p><strong>Master Project Created By:</strong> {project.masterProjectCreator}</p>
                    <p><strong>Project Has Hierarchy:</strong> {project.isLevel ? "Yes" : "No"}</p>
                  </div>
                )}
                {selectedViewMemberProjectId === project._id && (
                  <div>
                    {project.myProjectMembers.length > 0 ? (
                      project.myProjectMembers.map((projectmember, index) => (
                        <div key={index} className='bg-gray-200 text-black border-b border-b-yellow-300 mb-1'>
                          <p><strong>SN:</strong> {index+1}</p>
                          <p><strong>Member Name:</strong><span className="text-blue-500"> {projectmember.name}</span></p>
                          <p><strong>Created Date:</strong> {formatDateTime(projectmember.dateJoined)}</p>
                          <p><strong>Status:</strong> {projectmember.isActive ? "Active" : "Left"}</p>
                        </div>
                      ))
                    ) : (
                      <div className='bg-gray-200 text-black'>
                        <p>No Other Member Found</p>
                      </div>
                    )}
                  </div>
                )}
                {selectedAddMemberProjectId === project._id && (
                  <div>
                    <div className='mb-4 flex text-wrap justify-center'>
                      <p className='text-white'>Input a 14 Characters Alphanumeric Think5Whys User Code Starting with TU:</p>
                    </div>
                    <div className="mb-4 flex justify-center">
                      <input
                        type="text"
                        name="newMemberCode"
                        id="newMemberCode"
                        value={newMemberCode}
                        placeholder="Input Referrer ID"
                        onChange={(e) => setNewMemberCode(e.target.value)}
                        className="h-12 text-center p-2 border border-gray-300"
                      />
                    </div>
                    <div className="mb-4 flex justify-center">
                      {error && <p className="text-red-800 justify-left">{error}</p>}
                    </div>
                    <div className='mb-4 flex flex-col items-center'>
                      <p className={newMemberCodeStatus ? "text-green-800 text-lg" : "text-red-600 text-lg"}>
                        {newMemberCodeStatusMsg}
                      </p>
                      <button
                        type="button"
                        className="block w-full md:w-auto bg-green-800 text-white py-2 px-4 rounded-md font-medium hover:bg-primary-dark"
                        onClick={() => {
                          newMemberCodeValidationClicked(newMemberCode);
                          handleNewMemberCodeValidation();
                        }}
                        disabled={newMemberCodeStatus}
                      >
                        {newMemberCodeStatus ? "User ID Validated" : "Validate User ID"}
                      </button>
                    </div>
                    {newMemberCodeStatus && (
                      <div className="mb-2">
                        <div className="mb-4 text-lg text-white">
                          <div>
                            <div className='flex justify-center'>
                              <p className='text-xl text-green-500'>
                                User Code {newMemberCode} Validated for Project: 
                                <span>{project.projectTitle}</span>
                              </p>
                            </div>
                            <div className='flex justify-center'>  
                              <button
                                type="button"
                                className="block w-full md:w-auto bg-green-800 text-white py-2 px-4 rounded-md font-medium hover:bg-primary-dark"
                                onClick={() => {
                                  addNewButtonClicked(project._id, project.projectCode, project.projectTitle, projectTypeNames[project.projectType], newMemberId, newMemberCode, newMemberName );
                                }}
                                disabled={addNewMemberRecordStatus}
                              >
                                Add {newMemberName} To Project {project.projectName}
                              </button>
                            </div>
                          </div>
                          <div className='flex justify-center'>
                              {addNewMemberRecordStatus ? (
                                <p className='text-xl text-green-500'>Member {newMemberName} Added To Your Project {project.projectTitle}</p>
                                )  : (
                                  <p className='text-xl text-red-500'>Problem in adding Member {newMemberName} To Your Project {project.projectTitle}</p>
                              )}
                            </div>
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </div>
            ))
          )}
        </div>
      </div>
    </MainLayout>
  );  
};

export default MyProjects;


